import { defineRecipe } from "@chakra-ui/react";

export const tabsListRecipe = defineRecipe({
  base: {
    display: "inline-flex",
    gap: 1,
    boxShadow: "0 0 13px 0 #cbd5e0",
    pt: 1,
    pb: 1,
    mb: 5,
    paddingInlineStart: 1,
    paddingInlineEnd: 1,
    overflowX: "auto",
    maxWidth: "100%",
    borderRadius: "40px",
    whiteSpace: "nowrap",
    listStyle: "none",
  },
});

export const tabsTriggerRecipe = defineRecipe({
  base: {
    display: "block",
    borderColor: "currentColor",
    fontWeight: "bold",
    fontSize: "md",
    py: 2,
    px: 4,
    borderRadius: "20px",
    transition: "0.2s all ease-in-out",
    _hover: {
      bg: "#edf2f7",
    },
    _selected: {
      color: "white",
      bg: "#3b82f6",
      _hover: {
        bg: "#3b82f6",
      },
    },
    _before: {
      display: "none",
    },
  },
});
